<template>
  <div>
    <v-text-field
      v-model="tempdata"
      :label="date.label"
      :prepend-icon="date.icon"
      :hint="date.hint"
      @click:append="openDialog()"
      append-icon="calendar_today"
      persistent-hint
      readonly
    ></v-text-field>
      <v-dialog
        v-model="dialog"
        width="290"
      >
        <v-card v-if="this.date.obj !== 'stats.dcrt'">
          <v-card-title>
            <v-icon large left :color="ui.iconColor"> today </v-icon>
            <span :class="ui.textTitle"> {{calendarTitle}} </span>
            <v-spacer/>
          </v-card-title>
          <v-date-picker v-model="datepicked" :color="ui.textColor"></v-date-picker>
          <v-card-actions>
            <v-btn
            @click="closeDialog()" :color="ui.btnColor" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn
            v-if="this.datepicked !== '' && this.enableDateChange"
            @click="selectDate()" :color="ui.btnColor" flat>
              <v-icon left> edit_calendar </v-icon>
              select
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-card-title>
            <v-icon large left :color="ui.iconColor"> today </v-icon>
            <span :class="ui.textTitle"> {{calendarTitle}} </span>
            <v-spacer/>
          </v-card-title>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4 mr-4 mb-4">
              Document date created is recorded when the document was saved originally in the database. The date is not able to be modified, and the date is a reference point for some business processes metrics and governance.
            </div>
          </v-layout>
          <v-card-actions>
            <v-btn
            @click="closeDialog()" :color="ui.btnColor" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import moment from "moment";

import { mapGetters } from "vuex";
export default {
  props: {
    date: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      datepicked: "",
      tempdata: "",
      label: ""
    };
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme
  ],
  computed: {
    ...mapGetters([
      "getCurrentPage",
      "getDetailStats",
      "getDetailBasic",
      "getStatsRemote"
    ]),
    calendarTitle() {
      let title = null;
      if (this.date.obj === "stats.dcrt") {
        title = "Date Created";
      } else if (this.date.obj === "stats.dexp") {
        title = "Expiry Date";
      } else if (this.getDetailBasic.tag === "W2") {
        title = "Dates is Planned";
      } else {
        title = "Select Date";
      }
      return title;
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
      // this.$store.dispatch("changeInfoCard", null);
    },
    closeDialog() {
      this.dialog = false;
      // this.$store.dispatch("changeInfoCard", null);
    },
    enableDateChange() {
      let logic = null;
      if (this.date.obj == "stats.dexp") {
        logic = true;
      } else if (
        this.getDeatilBasic !== null &&
        this.getDetailBasic.tag === "W2"
      ) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    selectDate() {
      let stats = null;
      if (this.date.obj === "stats.dexp" && this.getStatsRemote !== null) {
        stats = this.getStatsRemote;
      } else {
        stats = this.getDetailStats;
      }
      let dateMoment = moment(this.datepicked).format();
      // eslint-disable-next-line
      if (this.date.obj === "stats.dvalid") {
        stats.dvalid = dateMoment;
      }
      if (this.date.obj === "stats.dcont") {
        stats.dcont = dateMoment;
      }
      if (this.date.obj === "stats.dmob") {
        stats.dmob = dateMoment;
      }
      if (this.date.obj === "stats.demob") {
        stats.demob = dateMoment;
      }
      if (this.date.obj === "stats.dedit") {
        stats.dedit = dateMoment;
      }
      if (this.date.obj === "stats.dexp") {
        stats.dexp = dateMoment;
      }
      if (this.date.obj === "stats.dstr") {
        stats.dstr = dateMoment;
      }
      if (this.date.obj === "stats.dend") {
        stats.dend = dateMoment;
      }
      if (this.date.obj === "stats.dcomp") {
        stats.dcomp = dateMoment;
      }
      if (this.date.obj === "stats.dplan") {
        stats.dplan = dateMoment;
      }
      if (this.date.obj === "stats.ddue") {
        stats.ddue = dateMoment;
      }
      if (this.date.obj === "stats.nread") {
        stats.nread = dateMoment;
      }
      if (this.date.obj === "stats.dexp") {
        stats.dexp = dateMoment;
      }
      if (this.date.obj === "stats.dstr") {
        stats.dstr = dateMoment;
      }
      if (this.date.obj === "stats.dend") {
        stats.dend = dateMoment;
      }
      if (this.date.obj === "stats.dstr") {
        stats.dstr = dateMoment;
      }
      if (this.date.obj === "stats.dend") {
        stats.dend = dateMoment;
      }
      if (this.date.obj === "stats.devent") {
        stats.devent = dateMoment;
      }
      if (this.date.obj === "stats.drev") {
        stats.drev = dateMoment;
      }

      // UPDATE
      if (this.date.obj === "stats.dexp" && this.getStatsRemote !== null) {
        this.$store.dispatch("changeStatsRemote", stats);
      } else {
        this.$store.dispatch("changeDetailStats", stats);
        this.saveDocumentRevMod(4.18, 1); // business mod.
      }

      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.dialog = false;
    }
  }
};
</script>
